// theme.js — Lumax Innovations

document.addEventListener("DOMContentLoaded", function () {
  let quoteSubmittedTracked = false;

  function trackQuoteSubmitted(source, formId) {
    if (quoteSubmittedTracked) {
      return;
    }

    quoteSubmittedTracked = true;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "quote_submitted",
      form_id: formId || "1058120",
      form_source: source,
      page_path: window.location.pathname,
    });
  }

  document.querySelectorAll("a[href^='tel:']").forEach(function (link) {
    link.addEventListener("click", function () {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "phone_click",
        phone_number:
          link.dataset.phoneNumber || link.getAttribute("href").replace("tel:", ""),
        link_url: link.href,
        page_path: window.location.pathname,
      });
    });
  });

  if (document.querySelector("[data-quote-form-success]")) {
    trackQuoteSubmitted("shopify_contact", "native-contact-form");
  }

  const quoteAppForm = document.querySelector("[data-quote-app-form]");

  if (quoteAppForm) {
    const quoteFormId = quoteAppForm.dataset.quoteFormId || "1058120";
    const successPhrases = [
      "thank you",
      "quote request has been received",
      "request has been received",
    ];
    const startedAt = Date.now();

    function isVisible(element) {
      if (!(element instanceof Element) || element.getClientRects().length === 0) {
        return false;
      }

      const styles = window.getComputedStyle(element);
      return styles.display !== "none" && styles.visibility !== "hidden";
    }

    function getSearchRoots() {
      const roots = [quoteAppForm];

      quoteAppForm.querySelectorAll("*").forEach(function (element) {
        if (element.shadowRoot) {
          roots.push(element.shadowRoot);
        }
      });

      return roots;
    }

    function appFormShowsSuccess() {
      const roots = getSearchRoots();
      let hasVisibleSubmit = false;
      let hasVisibleSuccess = false;

      roots.forEach(function (root) {
        root
          .querySelectorAll('button[type="submit"], input[type="submit"]')
          .forEach(function (button) {
            if (isVisible(button)) {
              hasVisibleSubmit = true;
            }
          });

        root
          .querySelectorAll('h1, h2, h3, p, [role="status"], [aria-live]')
          .forEach(function (element) {
            const text = element.textContent.trim().toLowerCase();

            if (
              isVisible(element) &&
              successPhrases.some(function (phrase) {
                return text.includes(phrase);
              })
            ) {
              hasVisibleSuccess = true;
            }
          });
      });

      return hasVisibleSuccess && !hasVisibleSubmit;
    }

    const quoteSuccessTimer = window.setInterval(function () {
      if (appFormShowsSuccess()) {
        window.clearInterval(quoteSuccessTimer);
        trackQuoteSubmitted("shopify_forms", quoteFormId);
        return;
      }

      if (Date.now() - startedAt > 10 * 60 * 1000) {
        window.clearInterval(quoteSuccessTimer);
      }
    }, 500);
  }

  const hamburger = document.getElementById("nav-hamburger");
  const drawer = document.getElementById("nav-drawer");

  if (hamburger && drawer) {
    hamburger.addEventListener("click", function () {
      closeSearch();
      drawer.classList.toggle("is-open");
      hamburger.setAttribute(
        "aria-expanded",
        String(drawer.classList.contains("is-open")),
      );
    });
  }

  const searchToggle = document.querySelector("[data-search-toggle]");
  const searchPanel = document.querySelector("[data-search-panel]");
  const searchClose = document.querySelector("[data-search-close]");
  const searchInput = document.querySelector("[data-search-input]");
  const predictiveForm = document.querySelector("[data-predictive-search]");
  const predictiveResults = document.querySelector("[data-predictive-results]");
  let predictiveTimer;
  let predictiveRequest;

  function closePredictiveSearch() {
    if (!predictiveResults || !searchInput) {
      return;
    }

    predictiveResults.hidden = true;
    predictiveResults.innerHTML = "";
    searchInput.setAttribute("aria-expanded", "false");
  }

  function openPredictiveSearch() {
    if (!predictiveResults || !searchInput) {
      return;
    }

    predictiveResults.hidden = false;
    searchInput.setAttribute("aria-expanded", "true");
  }

  function fetchPredictiveResults(searchTerm) {
    if (!predictiveForm || !predictiveResults || !searchInput) {
      return;
    }

    predictiveRequest?.abort();
    predictiveRequest = new AbortController();

    predictiveResults.innerHTML =
      '<p class="lumax-predictive-search__message">Searching products…</p>';
    openPredictiveSearch();

    const endpoint = predictiveForm.dataset.predictiveUrl || "/search/suggest";
    const params = new URLSearchParams({
      q: searchTerm,
      "resources[type]": "product",
      "resources[limit]": "6",
      "resources[options][unavailable_products]": "last",
      section_id: "predictive-search",
    });

    fetch(`${endpoint}?${params.toString()}`, {
      signal: predictiveRequest.signal,
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error(`Predictive search failed: ${response.status}`);
        }
        return response.text();
      })
      .then(function (text) {
        const responseDocument = new DOMParser().parseFromString(
          text,
          "text/html",
        );
        const section = responseDocument.querySelector(
          "#shopify-section-predictive-search",
        );

        if (!section || searchInput.value.trim() !== searchTerm) {
          return;
        }

        predictiveResults.innerHTML = section.innerHTML;
        openPredictiveSearch();
      })
      .catch(function (error) {
        if (error.name !== "AbortError") {
          closePredictiveSearch();
        }
      });
  }

  function setSearchState(isOpen) {
    if (!searchToggle || !searchPanel) {
      return;
    }

    searchPanel.classList.toggle("is-open", isOpen);
    searchToggle.setAttribute("aria-expanded", String(isOpen));

    if (isOpen) {
      if (drawer) {
        drawer.classList.remove("is-open");
      }
      if (hamburger) {
        hamburger.setAttribute("aria-expanded", "false");
      }
      window.requestAnimationFrame(function () {
        searchInput?.focus();
        searchInput?.select();
      });
    }
  }

  function closeSearch() {
    window.clearTimeout(predictiveTimer);
    predictiveRequest?.abort();
    closePredictiveSearch();
    setSearchState(false);
  }

  if (searchToggle && searchPanel) {
    searchToggle.addEventListener("click", function () {
      if (searchPanel.classList.contains("is-open")) {
        closeSearch();
      } else {
        setSearchState(true);
      }
    });

    searchClose?.addEventListener("click", closeSearch);

    searchInput?.addEventListener("input", function () {
      const searchTerm = searchInput.value.trim();
      window.clearTimeout(predictiveTimer);

      if (searchTerm.length < 2) {
        predictiveRequest?.abort();
        closePredictiveSearch();
        return;
      }

      predictiveTimer = window.setTimeout(function () {
        fetchPredictiveResults(searchTerm);
      }, 250);
    });

    searchInput?.addEventListener("keydown", function (event) {
      if (event.key === "ArrowDown" && !predictiveResults?.hidden) {
        const firstResult = predictiveResults.querySelector("a");
        if (firstResult) {
          event.preventDefault();
          firstResult.focus();
        }
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && searchPanel.classList.contains("is-open")) {
        closeSearch();
        searchToggle.focus();
      }
    });
  }

  document
    .querySelectorAll("[data-shipping-estimator]")
    .forEach(function (estimator) {
      const province = estimator.querySelector("[data-shipping-province]");
      const zip = estimator.querySelector("[data-shipping-zip]");
      const button = estimator.querySelector("[data-shipping-calculate]");
      const results = estimator.querySelector("[data-shipping-results]");

      if (!province || !zip || !button || !results) {
        return;
      }

      function showShippingMessage(message, isError) {
        results.innerHTML = "";
        const paragraph = document.createElement("p");
        paragraph.className = `lumax-cart__shipping-message${isError ? " lumax-cart__shipping-message--error" : ""}`;
        paragraph.textContent = message;
        results.appendChild(paragraph);
      }

      function formatShippingPrice(rate) {
        const currency = rate.currency || estimator.dataset.currency || "USD";
        const amount = Number.parseFloat(rate.price);

        if (!Number.isFinite(amount)) {
          return rate.price;
        }

        try {
          return new Intl.NumberFormat(document.documentElement.lang || "en-US", {
            style: "currency",
            currency,
          }).format(amount);
        } catch (error) {
          return `$${amount.toFixed(2)}`;
        }
      }

      function renderShippingRates(rates) {
        results.innerHTML = "";

        if (!rates.length) {
          showShippingMessage(
            "No standard shipping rates were found for this address. Please contact us for freight assistance.",
            false,
          );
          return;
        }

        const list = document.createElement("ul");
        list.className = "lumax-cart__shipping-rates";

        rates.forEach(function (rate) {
          const item = document.createElement("li");
          const name = document.createElement("span");
          const price = document.createElement("strong");

          item.className = "lumax-cart__shipping-rate";
          name.textContent = rate.presentment_name || rate.name;
          price.textContent = formatShippingPrice(rate);
          item.append(name, price);
          list.appendChild(item);
        });

        results.appendChild(list);
      }

      function wait(milliseconds) {
        return new Promise(function (resolve) {
          window.setTimeout(resolve, milliseconds);
        });
      }

      async function calculateShipping() {
        const postalCode = zip.value.trim();
        const provinceName = province.value;

        if (!provinceName) {
          showShippingMessage("Select a state to calculate shipping.", true);
          province.focus();
          return;
        }

        if (!/^\d{5}(?:-\d{4})?$/.test(postalCode)) {
          showShippingMessage("Enter a valid US ZIP Code.", true);
          zip.focus();
          return;
        }

        button.disabled = true;
        button.textContent = "Calculating…";
        showShippingMessage("Checking available shipping rates…", false);

        const root = window.Shopify?.routes?.root || "/";
        const params = new URLSearchParams({
          "shipping_address[zip]": postalCode,
          "shipping_address[country]": "United States",
          "shipping_address[province]": provinceName,
        });

        try {
          const prepareResponse = await fetch(
            `${root}cart/prepare_shipping_rates.json?${params.toString()}`,
            {
              method: "POST",
              credentials: "same-origin",
            },
          );

          if (!prepareResponse.ok) {
            throw new Error(`Shipping estimate failed: ${prepareResponse.status}`);
          }

          let ratesResponse = null;

          for (let attempt = 0; attempt < 10; attempt += 1) {
            await wait(650);
            const response = await fetch(
              `${root}cart/async_shipping_rates.json?${params.toString()}`,
              { credentials: "same-origin" },
            );

            if (!response.ok) {
              throw new Error(`Shipping estimate failed: ${response.status}`);
            }

            ratesResponse = await response.json();
            if (ratesResponse?.shipping_rates) {
              break;
            }
          }

          if (!ratesResponse?.shipping_rates) {
            throw new Error("Shipping estimate timed out");
          }

          renderShippingRates(ratesResponse.shipping_rates);
        } catch (error) {
          showShippingMessage(
            "We couldn't calculate shipping right now. Please try again or contact our team.",
            true,
          );
        } finally {
          button.disabled = false;
          button.textContent = "Calculate shipping";
        }
      }

      button.addEventListener("click", calculateShipping);
      zip.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          event.preventDefault();
          calculateShipping();
        }
      });
    });

  function setFacetState(facet, isExpanded) {
    const button = facet
      .closest(".lumax-collection-main__facet")
      ?.querySelector("[data-facet-toggle]");

    facet.classList.toggle("is-expanded", isExpanded);
    facet.classList.toggle("is-collapsed", !isExpanded);

    if (button) {
      button.classList.toggle("is-expanded", isExpanded);
      button.textContent = isExpanded ? "Show less" : "Show more";
      button.setAttribute("aria-expanded", String(isExpanded));
    }

    facet
      .querySelectorAll(".lumax-collection-main__facet-link.is-hidden")
      .forEach(function (link) {
        link.style.display = isExpanded ? "flex" : "none";
      });
  }

  document.querySelectorAll("[data-facet-toggle]").forEach(function (button) {
    button.addEventListener("click", function () {
      const facetGroup = button.closest(".lumax-collection-main__facet");
      const facet = facetGroup
        ? facetGroup.querySelector("[data-facet-list]")
        : null;

      if (!facet) {
        return;
      }

      const facetKey = facet.dataset.facetKey || "default";
      const storageKey = `lumaxFacetExpanded:${facetKey}`;
      const isExpanded = !facet.classList.contains("is-expanded");

      setFacetState(facet, isExpanded);

      try {
        window.localStorage.setItem(storageKey, isExpanded ? "1" : "0");
      } catch (error) {
        // ignore storage failures
      }
    });
  });

  document.querySelectorAll("[data-facet-list]").forEach(function (facet) {
    const facetKey = facet.dataset.facetKey || "default";
    const storageKey = `lumaxFacetExpanded:${facetKey}`;
    const hasActiveItem =
      facet.querySelector(".lumax-collection-main__facet-link.is-active") !==
      null;

    let shouldExpand = hasActiveItem;

    try {
      shouldExpand =
        hasActiveItem || window.localStorage.getItem(storageKey) === "1";
    } catch (error) {
      shouldExpand = hasActiveItem;
    }

    setFacetState(facet, shouldExpand);
  });

  document
    .querySelectorAll("[data-mobile-filter-toggle]")
    .forEach(function (button) {
      const section = button.closest(".lumax-collection-main");
      const panel = section?.querySelector("[data-mobile-filter-panel]");
      const label = button.querySelector("[data-mobile-filter-label]");

      if (!panel) {
        return;
      }

      button.addEventListener("click", function () {
        const isOpen = panel.classList.toggle("is-open");
        button.setAttribute("aria-expanded", String(isOpen));

        if (label) {
          label.textContent = isOpen ? "Hide filters" : "Filter";
        }
      });
    });
});
